import { withInstall } from '@tw-element/utils'

import Col from './src/col'

export const TwCol = withInstall(Col)
export default TwCol

export * from './src/col'
